module.exports = __webpack_public_path__ + "static/img/DaimlerCS-Regular.55543f66.svg";